// src/services/userService.js
import apiClient from './apiClient';

const userService = {
  // Obtener todos los usuarios
  getAllUsers: async () => {
    try {
      const response = await apiClient.get('/users/getAll');
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuarios:', error);
      throw error;
    }
  },
  
  // Obtener un usuario por ID
  getUserById: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener usuario ${userId}:`, error);
      throw error;
    }
  },
  
  // Crear un nuevo usuario
// Enhanced createUser method with better debugging
createUser: async (userData) => {
  try {
    console.log('Sending user data to backend:', JSON.stringify(userData, null, 2));
    const response = await apiClient.post('/users', userData);
    console.log('Response from backend:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error details:', {
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      data: error.response?.data
    });
    throw error;
  }
},
  
  // Actualizar un usuario existente
  updateUser: async (userId, userData) => {
    try {
      const response = await apiClient.put(`/users/updateUser/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar usuario ${userId}:`, error);
      throw error;
    }
  },
  
  // Eliminar un usuario
  deleteUser: async (userId) => {
    try {
      const response = await apiClient.delete(`/users/deleteUser?idCard=${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar usuario ${userId}:`, error);
      throw error;
    }
  }
};

export default userService;